class BeforeAndAfter extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.listeners.add(
      this.els.slider.element,
      'input',
      this.updatePosition.bind(this),
    )
  }

  updatePosition (e) {
    const position = Number(e.target.value)
    this.style.setProperty('--Position', `${position}%`)
  }
}
if (!customElements.get('before-and-after')) {
  customElements.define('before-and-after', BeforeAndAfter)
}
